import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import location from "../../../assets/icons/location.png";
import homeimg from "../../../assets/images/homeimg.png";
import AoutoPlaces from '../../../components/autoPlaces/AoutoPlaces';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import {
  useJsApiLoader,
  GoogleMap,
  Autocomplete,
  DirectionsRenderer,
} from '@react-google-maps/api'
import styled from 'styled-components';
import Geocode from "react-geocode";
import { useHistory, useNavigate } from 'react-router-dom';

import { GoogleApiWrapper } from 'google-maps-react';
import { getAllProperties } from '../../search/service/GetAllPropertiesApi';
function TopSection() {
 const  dispatch = useDispatch()
 const  navigate = useNavigate()
  const { getCurrentLocation } = useSelector((state) => state?.shareSlice)
  const [searchAddress, setSearchAddress] = useState('')
  const [homeLatitude, setHomeLatitude] = useState('')
  const [homeLongitude, setHomeLongitude] = useState('')
  const [addresses, setAddressess] = useState([])
  const [selectedPlace, setSelectedPlace] = useState(null);
  const autocomplete = useRef(null);
  const lat = localStorage.getItem('lat')
  const lng = localStorage.getItem('lng')
  useEffect(() => {
    dispatch(getAllProperties())
}, [dispatch]);

// const { isLoaded } = useJsApiLoader({
//   id: 'google-map-script',
//   googleMapsApiKey: `${process.env.REACT_APP_MAP_KEY}`,
// });
useEffect(() => {
  if (selectedPlace !== null) {
    const lat = selectedPlace.geometry.location.lat();
    const lng = selectedPlace.geometry.location.lng();
    setHomeLatitude(lat);
    setHomeLongitude(lng);
  }
}, [selectedPlace]);

const handlePlaceChanged = () => {
  if (autocomplete.current !== null) {
    const place = autocomplete.current.getPlace();
    setSelectedPlace(place);
  }
};
  const fetchAddresses = async () => {
    try {
      const response = await Geocode.fromLatLng(lat, lng);
      const addresses = response.results.map((result) => result.formatted_address);
      setAddressess(addresses)
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangeAddress = (address) => {
    setSearchAddress(address);
};
const handleSelect = async (address) => {
  try {
    const results = await geocodeByAddress(address);
    const selectedPlace = results[0];
    const { lat, lng } = await getLatLng(selectedPlace); 
    setHomeLatitude(lat)
    setHomeLongitude(lng)
    setSearchAddress(address)
  } catch (error) {
    console.error('Error retrieving place details:', error);
  }

};

const handleSubmit = ()=>{
  navigate('search', {
    state: {
      homeLatitude,
      homeLongitude
    }
  });
}
   useEffect(() => {
      fetchAddresses()
  }, []);
  const StyledInput = styled.input`
  &:focus {
    outline: none;
    border-color: blue; /* change this to your desired focus color */
    box-shadow: 0 0 0 2px blue; /* add a box shadow for focus effect if desired */
    
  }
`;

  return (
         <div className="row ">
        <div className="to-gain" >
          <div className="m-0 row">
            <div className="col-lg-1 col-md-1 col-sm-1 col-12"></div>
            <div className="col-lg-5 col-md-5 col-sm-5 col-12">
              <div className="propertytalks">
                <div>
                  <h2>Eign to gain your property deal</h2>
                  <div className="search-field">
                    <div>
                        <img src={location} alt="location" />
                        <Autocomplete
                          onLoad={(auto) => (autocomplete.current = auto)}
                          onPlaceChanged={handlePlaceChanged}
                        >
                          <input type="text" placeholder={getCurrentLocation.city} />
                        </Autocomplete>
                    </div>
                    <button onClick={handleSubmit}>Search</button>
                </div>
                 {/* <div className="search-feild">
                 <PlacesAutocomplete
                      value={searchAddress}
                      onChange={handleChangeAddress}
                      onSelect={handleSelect}
                      suggestions={addresses.filter((address) =>
                        address.toLowerCase().includes(searchAddress.toLowerCase())
                      )}
                    >
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <div className="input-container">
                          <img src={location} alt="icon" className="location-icon" />
                          <input
                        style={{
                          outline: 'none',
                          // add any other desired styles here
                        }}
                        {...getInputProps({
                          placeholder: `${getCurrentLocation.city}`,
                          className: 'location-search-input',
                        })}
                      />
                            <button onClick={handleSubmit}>Search</button>
                          </div>
                          <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map((suggestion) => {
                              const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                              const style = suggestion.active
                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                              return (
                                <div
                                  key={suggestion.placeId}
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                 </div> */}
                  <p>
                    Be in charge of your real estate transaction with access to
                    a comprehensive marketplace of houses.
                  </p>
                </div>
              </div>
              <div className="backimg" style={{ display: "none"}}>
                <img src={homeimg} alt="home" />
              </div>
            </div>
            <div className="p-0 col-lg-6 col-md-6 col-sm-6 col-12">
              <div className="mainbg">
                <img src={homeimg} alt="home" />
              </div>
            </div>
          </div>
        </div>
        <div className="centertext">
          <h3> Eign is The Ultimate Platform for Online Real Estate</h3>
          <p>Find out how EIGN can help you</p>
        </div>
      </div>

  )
}
export default GoogleApiWrapper({
  apiKey: 'AIzaSyBarK2r8HSxO1uiWJL53BEosVTHaW-U5vY'
})(TopSection);
